var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96571 0.876177L6.10622 4.73566L2.24674 0.876177C1.90075 0.530195 1.32838 0.530195 0.982401 0.876177C0.636419 1.22216 0.636419 1.79453 0.982401 2.14051L4.84189 6L0.982401 9.85949C0.636419 10.2055 0.636419 10.7778 0.982401 11.1238C1.32838 11.4698 1.90075 11.4698 2.24674 11.1238L6.10622 7.26434L9.96571 11.1238C10.3117 11.4698 10.8841 11.4698 11.23 11.1238C11.576 10.7778 11.576 10.2055 11.23 9.85949L7.37056 6L11.23 2.14051C11.576 1.79453 11.576 1.22216 11.23 0.876177C10.8841 0.530195 10.3117 0.530195 9.96571 0.876177Z",
    fill: "#212121",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.c4cad258a9cd1c9b2dbe18f34b14de78.svg";
export { ForwardRef as ReactComponent };